import React from 'react';
import { studyCalculators } from './ConstantsStudyCalculator';
import SharedHelmet from '.././Helmet'
import img from '../../../images/StudyCalculatorImg.webp';
const TITLE = 'Kalkulator Studi - Kalkulator Gratis untuk Menghitung IPK dan Nilai';
const DESCRIPTION = 'Jelajahi berbagai kalkulator studi gratis, termasuk kalkulator IPK dan konversi nilai antar sistem penilaian yang berbeda.';
const KEYWORDS = 'kalkulator studi, kalkulator gratis, kalkulator IPK, kalkulator konversi nilai, GPA, sistem penilaian';
const OG_URL = 'https://do-calculate.com/id/study-calculators';
function CalculatorsList() {
    return (
        <div className="container ">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div  >
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-secondary" role="alert">
                    <p>{DESCRIPTION} </p>
                </div>
            </div>
            <hr/>
            <table >
                <thead>
                    <tr >
                        <th className="gpa-header">Kalkulator</th>
                        <th className="gpa-header">Deskripsi</th>
                     </tr>
                </thead>
                <tbody>
                    {studyCalculators.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}
export default CalculatorsList;